import { createSlice,PayloadAction} from '@reduxjs/toolkit';
import {saveFirebase,getNotifications,markAllNotfication,markNotfication
} from '../api/firebaseThunk';
import {Notification} from '@/utils/interface';

interface State {
    data:Notification[]|null;
    message:string;
    isLoading: boolean;
    isError:boolean;

    postLoading:boolean;

  }
  
  const initialState: State = {
    data:null,
    message:"",
    isLoading: false,
    isError: false,

    postLoading:false,
  };

  const firebaseSlice = createSlice({
    name: 'firebase',
    initialState,
    reducers: {},

    extraReducers: (builder) => {
      builder

        .addCase(saveFirebase.pending, (state) => {
          state.isLoading = true;
          state.isError=false;
        })
        .addCase(saveFirebase.fulfilled, (state, action: PayloadAction<string>) => {
          state.isLoading = false;
          state.message = action.payload;
        })
        .addCase(saveFirebase.rejected, (state, action) => {
          state.isLoading = false;
          state.isError=true;
          state.message = action.payload as string;
        })  
        
        
        .addCase(getNotifications.pending, (state) => {
          state.isLoading = true;
          state.isError=false;
        })
        .addCase(getNotifications.fulfilled, (state, action: PayloadAction<Notification[]>) => {
          state.isLoading = false;
          state.data = action.payload;
        })
        .addCase(getNotifications.rejected, (state, action) => {
          state.isLoading = false;
          state.isError=true;
          state.message = action.payload as string;
        }) 


        .addCase(markAllNotfication.pending, (state) => {
          state.postLoading = true;
        })
        .addCase(markAllNotfication.fulfilled, (state, action: PayloadAction<string>) => {
          state.postLoading = false;
        })
        .addCase(markAllNotfication.rejected, (state, action) => {
          state.postLoading = false;
        }) 


        .addCase(markNotfication.pending, (state) => {
          state.postLoading = true;
        })
        .addCase(markNotfication.fulfilled, (state, action: PayloadAction<string>) => {
          state.postLoading = false;
        })
        .addCase(markNotfication.rejected, (state, action) => {
          state.postLoading = false;
        }) 
    },
  });
  
  export default  firebaseSlice.reducer;